import validate from "validate.js";
validate.options = {
    fullMessages: false
}

export default function validator(obj, constraints) {
    let result = validate(obj, constraints);
    result = result || true;
    return result;
}